/**
 * RISKS.ESTABLISHMENTS
 * Consult list of establishments
 */
import NavApp from "@/nav/nav.app"
import { useCallback, useEffect, useState } from "react"
import { useAppDispatch } from "@/core/root-reducer"
import establishmentStore from "@/entities/establishment/model/establishment.store"
import EstablishmentsConfig from "@/entities/establishment/ui/EstablishmentsConfig"
import { STATUS_LOADED, STATUS_LOADING, STATUS_LOAD_ERROR, StatusType } from "@/redux/_status.types"

function RisksEstablishmentsRoute() {
  const dispatch = useAppDispatch()
  const [loadStatus, setLoadStatus] = useState<StatusType>(STATUS_LOADING)

  const load = useCallback(async () => {
    setLoadStatus(STATUS_LOADING)
    try {
      const establishments = await dispatch(establishmentStore.thunks.fetchAndSet()).unwrap()
      const establishmentsWithUsers = establishments.map((est) => ({
        ...est,
        Users: est.Users ?? []
      }))
      dispatch(establishmentStore.actions.setList(establishmentsWithUsers))
      setLoadStatus(STATUS_LOADED)
    } catch (error) {
      console.error("Impossible de charger les établissements :", error)
      setLoadStatus(STATUS_LOAD_ERROR)
    }
  }, [dispatch])

  useEffect(() => {
    load()
  }, [load])

  return (
    <NavApp>
      <EstablishmentsConfig loadStatus={loadStatus} onRefresh={load} />
    </NavApp>
  )
}

export default RisksEstablishmentsRoute
